/**
 * useMumbaiRoutes — fetches /api/mumbai/routes once at mount, caches in state.
 * Used by BusMap to look up a route on bus-click and draw the polyline.
 */
import { useEffect, useState } from "react";
import { getBaseUrl } from "../lib/api";
export function useMumbaiRoutes() {
    const [routes, setRoutes] = useState({});
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let cancelled = false;
        fetch(`${getBaseUrl()}/api/mumbai/routes`)
            .then((r) => (r.ok ? r.json() : { routes: [] }))
            .then((j) => {
            if (cancelled)
                return;
            const map = {};
            for (const r of j.routes || [])
                map[r.route_id] = r;
            setRoutes(map);
            setLoading(false);
        })
            .catch(() => setLoading(false));
        return () => {
            cancelled = true;
        };
    }, []);
    return { byId: routes, loading, count: Object.keys(routes).length };
}
